function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { sendAnalytics } from '@audio-network/analytics';
import * as Styled from './Volume.styles';
import Slider from '../Slider/Slider';
import { useLocalStorage, usePlayerApi } from '../../hooks';
import VolumeSVGHelper from './VolumeSVGHelper';
var Volume = function Volume(_ref) {
  var interfaceText = _ref.interfaceText;
  var _usePlayerApi = usePlayerApi(),
    setVolume = _usePlayerApi.setVolume,
    mute = _usePlayerApi.mute,
    unmute = _usePlayerApi.unmute;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMuted = _useState2[0],
    setIsMuted = _useState2[1];
  var _useLocalStorage = useLocalStorage('userVolume', '0.5'),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    localVolume = _useLocalStorage2[0],
    setLocalVolume = _useLocalStorage2[1];
  useEffect(function () {
    if (localVolume === '0') {
      mute();
      setIsMuted(true);
    } else if (localVolume !== '0' && isMuted) {
      unmute();
      setIsMuted(false);
    }
    setVolume(localVolume);
  }, [localVolume]);
  var toggleMute = function toggleMute() {
    if (!isMuted) {
      mute();
    } else if (localVolume === '0' && isMuted) {
      setLocalVolume('0.5');
      unmute();
    } else {
      unmute();
    }
    setIsMuted(!isMuted);
  };
  var handleAnalytics = function handleAnalytics(volume) {
    sendAnalytics(null, 'Player', 'Volume Changed', {
      Volume: volume
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.Button, {
    id: "player-volume-button",
    "data-testid": "player-volume-button",
    type: "button",
    onClick: toggleMute,
    "aria-label": isMuted ? interfaceText['player-unmute'] : interfaceText['player-mute']
  }, /*#__PURE__*/React.createElement(VolumeSVGHelper, {
    isMuted: isMuted,
    localVolume: localVolume
  })), /*#__PURE__*/React.createElement(Slider, {
    "data-testid": "player-volume-slider",
    name: "Volume",
    value: localVolume,
    onChange: setLocalVolume,
    onMouseUp: handleAnalytics,
    hideThumb: true,
    step: 0.1
  }));
};
Volume.propTypes = {
  interfaceText: PropTypes.objectOf(PropTypes.string).isRequired
};
export default Volume;